import { SignedInvoiceFragment } from 'generated/resources/graphql'

export const signedInvoiceState = (signedInvoice: SignedInvoiceFragment): string => {
  const { parentExpense, expensesClosingPeriod } = signedInvoice
  const expenseStatus = parentExpense?.status

  if (expensesClosingPeriod) {
    return 'closed'
  }

  if (expenseStatus === 'approved' || expenseStatus === 'in_payroll' || expenseStatus === 'paid') {
    return 'ready_to_close'
  }

  return 'not_ready_to_close'
}
